import AbstractClient from './AbstractClient'
import store from 'store'

class CalendarClient extends AbstractClient {
  getEvents (start, end) {
    const current = store.getters['session/getCurrent']
    const session = store.getters['session/getSession']
    return super.get(`/tabcontrolli/calendario/aziende/${current.company.id}?start=${start}&end=${end}&ambito=${session.ambito}`)
  }

  getDetail (day) {
    const current = store.getters['session/getCurrent']
    return super.get(`/controlli/aziende/${current.company.id}/dettagli/${day}`)
  }

  updateDetail (day, data) {
    const current = store.getters['session/getCurrent']
    return super.post(`/controlli/aziende/${current.company.id}/dettagli/${day}`, data)
  }
}

export default new CalendarClient()
